import clsx from 'clsx';
import * as React from 'react';
import { polymorphicAsProp } from '../types';
import * as Styled from './Card.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Card = /*#__PURE__*/React.forwardRef(function Card({
  interactive = false,
  disabled = false,
  as = 'div',
  children,
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(Styled.Card, {
    ...polymorphicAsProp(as),
    ref: ref,
    className: clsx('ovpn-card', className),
    $interactive: interactive,
    $disabled: interactive && disabled,
    ...props,
    children: children
  });
});
export default Card;